import Component from "../inherited/Component";
import AjaxApi from "../lib/AjaxApi";

export default class CartCustomPermalink extends Component {
  constructor(elem, theme, options, ctx) {
    super(elem, theme, options, ctx);
  }

  async mount() {
    const location = window.location;

    if (!location.search.startsWith("?customPermalink")) {
      return;
    }

    const params = new URLSearchParams(location.search);


    const itemsParam = params.get("items");

    if (!itemsParam) {
      return;
    }

    const lineItems = [];

    itemsParam.split(",").forEach((item) => {
      const [id, quantity, ...rest] = item.split(":");

      if (!id || !quantity) {
        return;
      }

      const line = {
        id,
        quantity: parseInt(quantity),
        properties: {},
      };

      rest.forEach((property) => {
        const [key, value] = property.split("|");

        if (!key.startsWith("prop=")) {
          return;
        }

        line.properties[key.replace("prop=", "")] = value;
      });

      lineItems.push(line);
    });

    if (!lineItems) {
      return;
    }

    try {
      let data = await AjaxApi.addToCart(
        {
          items: lineItems,
        },
        this._ctx.getState()
      );

      debugger;

      params.delete("items");

      window.location.replace(`${location.origin}/checkout?${params.toString()}`);

    } catch (err) {
      console.log(err);
    }

    debugger;
  }
}
